<i (click)="showConfirm = true" *ngIf="showConfirm == false" [class]="buttonClass"></i>
<i *ngIf="showConfirm" (click)="showConfirm = false; confirm()" class="fas fa-check"></i>
<i *ngIf="showConfirm" (click)="showConfirm = false; cancel()" class="fas fa-times"></i>
